export const INTERVAL = {
    EVERY_WEEK: 'EVERY_WEEK',
    FIRST_AND_THIRD_WEEK: 'FIRST_AND_THIRD_WEEK',
    SECOND_AND_FOURTH_WEEK: 'SECOND_AND_FOURTH_WEEK',
};

export const WEEKDAYS_FULL = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
];

export const JOB_STATUS = {
    PENDING: 'PENDING',
    ACTIVE: 'ACTIVE',
    ASSIGNED: 'ASSIGNED',
    CANCELED: 'CANCELED',
};

export const JOB_PHASE = {
    PENDING: 'PENDING',
    ACTIVE: 'ACTIVE',
    WITHDRAWAL: 'WITHDRAWAL',
    CLOSED: 'CLOSED',
};

export const WORKFORCE_JOB_BID_STATUS = {
    SUBMITTED: 'SUBMITTED',
    WITHDRAWN: 'WITHDRAWN',
    ASSIGNED: 'ASSIGNED',
    REMOVED: 'REMOVED',
    WON_OTHER_BID: 'WON_OTHER_BID',
    SUCCESSFUL: 'SUCCESSFUL',
    UNSUCCESSFUL: 'UNSUCCESSFUL',
    NOT_FINALIZED: 'NOT_FINALIZED',
    CANCELED: 'CANCELED',
};

export const ASSIGNMENT_TYPE = {
    ASSIGNED: 'ASSIGNED',
    NO_QUALIFIED_BIDDER: 'NO_QUALIFIED_BIDDER',
    REVOKED: 'REVOKED',
    DELETE: 'DELETE',
};

// Waterloo-DTO, Waterloo-TCAO, Waterloo-IAM
export const WATERLOO_BIDDING_GROUP_IDS = [1, 2, 18];

// NAPDC,Dubuque,Davenport,Springfield,Coffeyville,Paton,Des Moines IAM, Des Moines UAW, Augusta, Cylinder, Seeding, Harvester UAW, Harvester IAM
export const ALLOWED_BIDDING_GROUPS_TO_WITHDRAW = [
    6, 16, 3, 19, 17, 20, 4, 5, 14, 12, 13, 10, 11,
];

export const BIDDER_ALREADY_WON_OTHER_BID_ERROR =
    'Bidder already won another bid in this bidding period';
